import React, { useRef, useState } from 'react';
import Cropper from 'react-cropper';
import { Modal } from 'react-bootstrap';
import $ from 'jquery';

import 'bootstrap/dist/css/bootstrap.min.css';

import '../../../../node_modules/cropperjs/dist/cropper.css';
import iconSpin from '../../../assets/images/icon_girar.svg';
import iconZoomOut from '../../../assets/images/icon_zoom_out.svg';
import iconZoomIn from '../../../assets/images/icon_zoom_in.svg';

const buttonRotateStyle = { marginRight: 150 };

const NewBotEditImgModal = (props) => {
  const { avatar, canRenderCropper } = props;
  const cropperRef = useRef(null);
  const [cropper, setCropper] = useState(null);

  const onCropperInit = (cropperInstance) => {
    setCropper(cropperInstance);
  };

  const onClickZoomIn = () => {
    if (cropper) {
      cropper.zoom(0.1);
    }
  };

  const onClickZoomOut = () => {
    if (cropper) {
      cropper.zoom(-0.1);
    }
  };

  const onClickRotate = () => {
    if (cropper) {
      cropper.rotate(90);
    }
  };

  const onClickCloseModal = (event) => {
    event.preventDefault();
    // const { setShowCropModal } = props;
    // setShowCropModal(false);
  };

  const onClickSaveImg = () => {
    if (cropper) {
      const { setCroppedImage, setShowCropModal } = props;
      const options = { height: 300, width: 300 };
      const canvas = cropper.getCroppedCanvas(options);
      const croppedImg = canvas.toDataURL();
      $('#newBotEditAvatar').modal('hide');
      setCroppedImage(croppedImg);
      setShowCropModal(false);
    }
  };

  const renderCropper = () => {
    if (!canRenderCropper) {
      return false;
    }

    return (
      <Cropper
        ref={cropperRef}
        src={avatar}
        style={{ height: '100%', width: '100%' }}
        dragMode="move"
        viewMode={2}
        initialAspectRatio={1}
        aspectRatio={1}
        autoCropArea={1}
        minCanvasHeight={300}
        minCanvasWidth={315}
        minContainerHeight={300}
        minContainerWidth={315}
        minCropBoxHeight={350}
        minCropBoxWidth={330}
        background={false}
        cropBoxMovable={false}
        cropBoxResizable={false}
        onInitialized={onCropperInit}
      />
    );
  };

  return (
    <div
      id="newBotEditAvatar"
      className="modal fade"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="newBotEditAvatar"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Cortar foto
            </h5>
            <button
              type="button"
              className="close new-bot-modal-close-button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={onClickCloseModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body new-bot-modal-body">{renderCropper()}</div>
          <div className="modal-footer new-bot-modal-footer">
            <button
              id="newBotCropZoomOut"
              type="button"
              data-method="zoom"
              data-option="-0.1"
              onClick={onClickZoomOut}
            >
              <img src={iconZoomOut} alt="Zoom out" />
            </button>
            <button
              id="newBotCropZoomIn"
              type="button"
              data-method="zoom"
              data-option="0.1"
              onClick={onClickZoomIn}
            >
              <img src={iconZoomIn} alt="Zoom in" />
            </button>
            <button
              id="newBotCropRotate"
              type="button"
              onClick={onClickRotate}
              style={buttonRotateStyle}
            >
              <img src={iconSpin} alt="Rotate" />
            </button>
            <button
              id="newBotCropSave"
              type="button"
              className="btn btn-primary"
              onClick={onClickSaveImg}
            >
              salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewBotEditImgModal;
